import { Link, Typography } from "@mui/material";
import { Routes, routeBreadcrumbs, routes, routeNames } from "config";
import React from "react";
import { useNavigate } from "react-router-dom";

export const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { pageName } = props;
  const navigate = useNavigate();
  const breadcrumbs = React.useMemo(() => routeBreadcrumbs[pageName], [pageName]);

  if (!breadcrumbs) {
    return null;
  }

  return (
    <div className="layout-breadcrumbs _d-flex-ali-center-sm-gap">
      {breadcrumbs.map((breadcrumb, i) => (
        <React.Fragment key={breadcrumb}>
          <Link
            onClick={() =>
              navigate(typeof routes[breadcrumb] === "string" ? routes[breadcrumb] : (routes[breadcrumb] as Function)())
            }
            color='text.secondary'
          >
            {typeof routeNames[breadcrumb] === "string" ? routeNames[breadcrumb] : (routeNames[breadcrumb] as Function)()}
          </Link>
          <Typography variant="h3" color='text.tertiary'>/</Typography>
        </React.Fragment>
      ))}
    </div>
  );
};

interface BreadcrumbsProps {
  pageName: Routes;
}
